module.exports = __webpack_public_path__ + "assets/email-btn-icon.svg";


//////////////////
// WEBPACK FOOTER
// ./images/icons/email-btn-icon.svg
// module id = 813
// module chunks = 0